import { Swiper, Navigation, Autoplay, EffectFade, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use([ Autoplay, EffectFade, Navigation, Pagination]);


document.addEventListener('DOMContentLoaded',function() {
    
    const cards = document.getElementsByClassName('js-cardsSwiper')[0],
          work = document.getElementsByClassName('js-workSwiper')[0];

    const cardsCarousel = function() {
        let mobile = false, swiper;

        const startSwiper = function() {
    	    swiper = new Swiper(cards, {
                breakpoints: {
                    768: {
                        paginatin: false
                    },
                    1025: {
                        slidesOffsetAfter: 0,
                        slidesOffsetBefore: 0
                    }
                },
                navigation: {
                    nextEl: '.c-cards .swiper-button-next',
                    prevEl: '.c-cards .swiper-button-prev',
                },
                pagination: {
                    el: '.c-cards .swiper-pagination',
                        clickable: true
                },
                slidesOffsetAfter: 18,
                slidesOffsetBefore: 18,
                slidesPerView: 'auto',
                spaceBetween: 32,
                speed: 800
            });
        };
        
        const init = function() {
            if (window.innerWidth < 1024) {
                if (mobile === false) {
                    swiper ? swiper.destroy() : false;
                    startSwiper();
                    mobile = true;
                }
            } else {
                startSwiper();
                mobile = false;
            }
        }
        
        init();
        
        window.addEventListener('resize', init);
    };

    const workCarousel = function() {
	    const swiper = new Swiper(work, {
    	    autoplay: {
                delay: 3000,
            },
    	    effect: 'fade',
    	    fadeEffect: {
                crossFade: true
            },
    	    allowTouchMove: false,
            speed: 800
        });
    };
        
    window.carousels = function() {
        cards ? cardsCarousel() : false;
        work ? workCarousel() : false;
    };

}, false)
